<template lang="pug">
div(v-if='data' class='space-y-12 content')
  ProductExtraInfoDescription(:data='data')

  template(v-if='data.specifications || data.howItWorks || data.additionalFeatures || data.faq')
    ProductExtraInfoDetails(id='scrollTarget-details' :data='data')

  template(v-if='data.videos?.videos')
    h2(id='scrollTarget-videos') Videos
    ProductExtraInfoVideoList(:videos='data.videos.videos' section='videos')

  ProductExtraInfoInstallation(v-if='data.installation' id='scrollTarget-install' :data='data')

  ProductExtraInfoWarranty(v-if='data.warranty' id='scrollTarget-warranty' :data='data')

  div(v-if='$device.isMobile' class='space-y-6')
    SimpleAccordion(v-if='!!$sitewideConfig.config.yotpoProductGalleryId' id='scrollTarget-photos' header='Customer Photos')
      YotpoCustomerPhotos(:yotpo-id='data.yotpoId' :gallery-id='$sitewideConfig.config.yotpoProductGalleryId')

    SimpleAccordion(id='scrollTarget-reviews' header='Reviews')
      YotpoReviews(:yotpo-id='data.yotpoId' :yotpo-name='data.name')

    SimpleAccordion(id='scrollTarget-qa' header='Q&A')
      YotpoQuestions(:yotpo-id='data.yotpoId' :yotpo-name='data.name')
  div(v-else class='space-y-12')
    div(v-if='$sitewideConfig.config.yotpoProductGalleryId')
      h2(id='scrollTarget-photos') Customer Photos
      YotpoCustomerPhotos(:yotpo-id='data.yotpoId' :gallery-id='$sitewideConfig.config.yotpoProductGalleryId')
    div
      h2(id='scrollTarget-reviews') Reviews
      YotpoReviews(:yotpo-id='data.yotpoId' :yotpo-name='data.name')
    div
      h2(id='scrollTarget-qa') Q&amp;A
      YotpoQuestions(:yotpo-id='data.yotpoId' :yotpo-name='data.name')
</template>
<script setup lang="ts">
const { $device, $sitewideConfig } = useNuxtApp()

const { data } = defineProps<{
  data: ProductLine
}>()
</script>
